import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { map, tap, catchError } from 'rxjs/operators';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { FormatUtils } from '../../shared/_utils/services/formatUtils';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { AcquisitionType } from '../entities/acquisition-type';

@Injectable()
export class AcquisitionTypeService extends BaseCrudService<AcquisitionType> {

  public uri = '/api/acquisitionType/';

  constructor(injector: Injector) {
    super(injector);
    // console.log('Instance AcquisitionTypeService');
  }

  buildSentence(entity?: AcquisitionType, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = entity.code ? 'code'
        + QueryOperator.Contain + entity.code
        + QueryOperator.Split : QueryOperator.Empty;
      query = query.concat(
        entity.name ? 'name'
          + QueryOperator.Contain + entity.name
          + QueryOperator.Split : QueryOperator.Empty
      );
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  getSequenceCode(): Observable<string> {
    const url = this.rutaServidor + this.uri + 'maxCode/';
    return this.httpClient.get<any>(url)
      .pipe(
        map(response => {
          // debugger;
          const code = response.maxCode ? response.maxCode : FormatUtils.padLeftZero(0, 3);
          const sequence = (parseInt(code, 10)) + 1;
          return FormatUtils.padLeftZero(sequence, 3);
        }),
        tap(response => {
          // console.log(response);
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/acquistion-type.service.ts